import { icons } from "./icons";
import { LABELS } from "./labels";
import { URLS } from "./urls";

export const STATUS_CODE = [400, 401, 403, 500];

export const DATE_FORMAT = {
  REGULAR: "DD MMM YYYY, HH:mm:ss",
  STANDARD: "DD/MM/YYYY",
  DASH: "DD-MM-YYYY",
  DATE_TIME: "DD/MM/YYYY hh:mm A",
};

export const PAGINATION_DROP = [
  { _id: 10, name: 10 },
  { _id: 50, name: 50 },
  { _id: 100, name: 100 },
  { _id: 200, name: 200 },
];

export const SEARCH_DATA = {
  search: undefined,
  filter: {},
  limit: 10,
  skip: 0,
  sort: "desc",
  sortBy: "createdAt",
  filterFlag: false,
  // searchFlag: false,
};

export const sidebarData: any = [
  {
    id: "1",
    title: LABELS.DASHBOARD_TEXT,
    path: URLS.DASHBOARD,
    icon: icons.ICON_DASHBOARD,
    permName: "store",
    type: "edit",
  },
  {
    id: "2",
    title: LABELS.STORE_MANAGEMENT_TEXT,
    path: URLS.STORE,
    icon: icons.ICON_STORE,
    permName: "store",
    type: "view",
  },
  {
    id: "5",
    title: LABELS.INVENTORY_TEXT,
    path: URLS.INVENTORY,
    icon: icons.ICON_INVENTORY,
    permName: "inventory",
    type: "view",
  },
  {
    id: "6",
    title: LABELS.VENDOR_MANAGEMENT_TEXT,
    path: URLS.VENDOR,
    icon: icons.ICON_BRAND,
    permName: "vendor",
    type: "view",
  },
  {
    id: "7",
    title: LABELS.ORDER_MANAGEMENT_TEXT,
    path: URLS.ORDER,
    icon: icons.ICON_ORDER,
    permName: "order",
    type: "view",
  },
  {
    id: "8",
    title: LABELS.CUSTOMER_MANAGEMENT_TEXT,
    path: URLS.CUSTOMER,
    icon: icons.ICON_CUSTOMERS,
    permName: "customer",
    type: "view",
  },

  {
    id: "9",
    title: LABELS.USER_MANAGEMENT_TEXT,
    icon: icons.ICON_USERS,
    visibleFor: [1],
    permName: "",
    type: "",
    subItems: [
      {
        id: "9-1",
        title: LABELS.USERS_TEXT,
        path: URLS.USER,
        visibleFor: [1],
      },
      {
        id: "9-2",
        title: LABELS.ROLES_TEXT,
        path: URLS.ROLES,
        visibleFor: [1],
      },
    ],
  },
  {
    id: "10",
    title: LABELS.STORE_COORDINATOR_TEXT,
    icon: icons.ICON_STORE_COORDINATORS,
    path: URLS.STORE_COORDINATOR,
    permName: "storeCoordinator",
    type: "view",
  },
  {
    id: "11",
    title: LABELS.REPORT_TEXT,
    path: URLS.REPORT,
    icon: icons.ICON_REPORTS,
    permName: "report",
    type: "view",
  },
  // {
  //   id: "11",
  //   title: LABELS.CUSTOMER_FEEDBACK_TEXT,
  //   path: URLS.CUSTOMER_FEEDBACK,
  //   icon: icons.ICON_FEEDBACK,
  //   permName: "customerFeedback",
  //   type: "view",
  //   visibleFor: [1],
  // },
  {
    id: "12",
    title: LABELS.UTILITY_TEXT,
    path: URLS.UTILITY,
    icon: icons.ICON_STORE_COORDINATOR,
    permName: "",
    type: "",
    visibleFor: [1],
  },
  {
    id: "13",
    title: LABELS.AUDIT_TRAIL_CONFIG_TEXT,
    path: URLS.AUDIT_TRAIL_CONFIG,
    icon: icons.ICON_REPORTS,
    permName: "order",
    type: "auditTrail",
    visibleFor: [1],
  },
  {
    id: "14",
    title: LABELS.FABRIC_WARNING_LOG_TEXT,
    path: URLS.FABRIC_WARNING_LOG,
    icon: icons.ICON_REPORTS,
    permName: "fabric",
    type: "view",
    visibleFor: [1, 2],
  },
  {
    id: "15",
    title: LABELS.CUSTOMER_FEEDBACK_LIST_TEXT,
    path: URLS.CUSTOMER_FEEDBACK_LIST,
    icon: icons.ICON_FEEDBACK,
    permName: "feedback",
    type: "view",
    visibleFor: [1],
  },
  {
    id: "16",
    title: LABELS.FEEDBACK_FORM_CONFIG_TEXT,
    path: URLS.FEEDBACK_CONFIG,
    icon: icons.ICON_FEEDBACK,
    permName: "feedback",
    type: "manage",
    visibleFor: [1],
  },
  {
    id: "17",
    title: LABELS.WHATSAPP_STAGES_TEXT,
    path: URLS.WHATSAPP_STAGES,
    icon: icons.ICON_NOTIFICATION,
    permName: "whatsapp",
    type: "view",
    visibleFor: [1, 2],
  },
  {
    id: "18",
    title: LABELS.WHATSAPP_TEMPLATES_TEXT,
    path: URLS.WHATSAPP_TEMPLATES,
    icon: icons.ICON_NOTIFICATION,
    permName: "whatsapp",
    type: "manage",
    visibleFor: [1, 2],
  },
  {
    id: "19",
    title: LABELS.WHATSAPP_LOG_TEXT,
    path: URLS.WHATSAPP_LOG,
    icon: icons.ICON_NOTIFICATION,
    permName: "whatsapp",
    type: "view",
    visibleFor: [1, 2],
  },
];

export const sidebarPaths: any = [
  URLS.DASHBOARD,
  URLS.STORE,
  URLS.INVENTORY,
  URLS.VENDOR,
  "/user-management",
  URLS.CUSTOMER,
  URLS.ORDER,
  "/order-details",
  URLS.STORE_COORDINATOR,
  URLS.USER_PROFILE,
  URLS.FABRIC_SETTINGS,
  URLS.FABRIC_WARNING_LOG,
  URLS.AUDIT_TRAIL_CONFIG,
];

export const PERMISSIONS = [
  "store.edit",
  "store.view",
  "inventory.edit",
  "inventory.view",
  "vendor.edit",
  "vendor.view",
  "order.edit",
  "order.view",
  "order.adminEdit",
  "order.auditTrail",
  "customer.edit",
  "customer.view",
  "storeCoordinator.edit",
  "storeCoordinator.view",
  "report.edit",
  "report.view",
  "customerFeedback.view",
  "fabric.edit",
  "fabric.view",
  "feedback.view",
  "feedback.manage",
  "whatsapp.view",
  "whatsapp.manage",
];

export const UserType = {
  SUPER: 1,
  BO: 2,
  SC: 3,
  S_CASH: 4,
};

export const USER_TYPE_DROP = [
  { _id: 3, name: "Store Coordinator" },
  { _id: 4, name: "Store Cashier" },
];

export const USER_TYPE: any = {
  1: " SUPER",
  2: "BO",
  3: "Store Coordinator",
  4: "Store Cashier",
};

export const OrderStatus = {
  PENDING: 1,
  CONFIRMED: 2,
  CANCELED: 3,
  CONFIRM_IN_PROGRESS: 4,
  PENDING_APPROVAL: 5,
  ON_HOLD: 6,
};

export const ORDER_STATUS = [
  { _id: 1, name: "CONFIRMATION_PENDING_TEXT", class: "text-warning" },
  { _id: 2, name: "CONFIRMED_TEXT", class: "text-success" },
  { _id: 3, name: "CANCELED_TEXT", class: "text-danger" },
  { _id: 4, name: "CONFIRM_IN_PROGRESS_TEXT", class: "text-info" },
  { _id: 5, name: "APPROVAL_PENDING_TEXT", class: "text-pending" },
  { _id: 6, name: "ON_HOLD_TEXT", class: "text-hold" },
];

export const GENDER_DROP = [
  { _id: "M", name: "MALE" },
  { _id: "F", name: "FEMALE" },
  { _id: "T", name: "TRANSGENDER" },
  { _id: "U", name: "UNDISCLOSED" },
];

export const PREF_COMMUNICATION_MODE_DROP = [
  { _id: "S", name: "SMS" },
  { _id: "E", name: "EMAIL" },
  { _id: "A", name: "ALL" },
];

export const ACTIVE_STATE = [
  { _id: "true", name: "Active" },
  { _id: "false", name: "InActive" },
];

export const USER_DECISION_DROP = [
  { _id: "continued", name: "Continued" },
  { _id: "cancelled", name: "Cancelled" },
  { _id: "dismissed", name: "Dismissed" },
];

export const DASHBOARD_ORDER_STATISTICS = [
  {
    id: "totalOrders",
    title: LABELS.TOTAL_ORDERS_TEXT,
    icon: icons.ICON_TOTAL_ORDERS,
  },
  {
    id: "confirmedOrders",
    title: LABELS.CONFIRM_ORDERS_TEXT,
    icon: icons.ICON_CONFIRM_ORDERS,
  },
  {
    id: "cancelledOrders",
    title: LABELS.CANCELLED_ORDERS_TEXT,
    icon: icons.ICON_CANCELED_ORDERS,
  },
  {
    id: "pendingOrders",
    title: LABELS.CONFIRMATION_PENDING_TEXT,
    icon: icons.ICON_PENDING_ORDERS,
  },
  {
    id: "confirmInProgressOrders",
    title: LABELS.CONFIRM_IN_PROGRESS_TEXT,
    icon: icons.ICON_CONFIRMATION_IN_PROGRESS,
  },

  {
    id: "pendingApprovalOrders",
    title: LABELS.APPROVAL_PENDING_TEXT,
    icon: icons.ICON_APPROVAL_PENDING,
  },
];

export const DASHBOARD_USER_STATISTICS = [
  {
    id: "totalUsers",
    title: LABELS.BACKOFFICE_USERS_TEXT,
    icon: icons.ICON_BACK_OFFICE,
  },
  {
    id: "totalStoreCoordinators",
    title: LABELS.STORE_CO_ORDINATOR_TEXT,
    icon: icons.ICON_STORE_COORDINATORS,
  },
  {
    id: "totalStoreCashiers",
    title: LABELS.STORE_CASHIER_TEXT,
    icon: icons.ICON_CASHIER,
  },
];

export const STATUS_DROP = [
  { _id: 1, name: LABELS.CONFIRMATION_PENDING_TEXT },
  { _id: 2, name: LABELS.CONFIRMED_TEXT },
  { _id: 3, name: LABELS.CANCELED_TEXT },
  { _id: 4, name: LABELS.CONFIRM_IN_PROGRESS_TEXT },
  { _id: 5, name: LABELS.APPROVAL_PENDING_TEXT },
  { _id: 6, name: LABELS.ON_HOLD_TEXT },
];

export const topMeasurement = [
  { _id: "sherwani", name: "sherwani" },
  { _id: "indo", name: "indo" },
  { _id: "jodhpuri", name: "jodhpuri" },
  { _id: "suits", name: "suits" },
  { _id: "alika", name: "alika" },
  { _id: "kurta", name: "kurta" },
  { _id: "bandi", name: "bandi" },
  { _id: "vest", name: "vest" },
  { _id: "shirt", name: "shirt" },
  { _id: "blazer", name: "blazer" },
  { _id: "bomber", name: "bomber" },
  { _id: "coat", name: "coat" },
];

export const bottomMeasurement = [
  { _id: "pant", name: "pant" },
  { _id: "aligadhi", name: "aligadhi" },
  { _id: "salwar", name: "salwar" },
  { _id: "chudidar", name: "chudidar" },
  { _id: "plazo", name: "plazo" },
  { _id: "dhoti", name: "dhoti" },
];

export const DEBOUNCE_VALUE = 750;

export const COMMENT_USER_ROLE = {
  STORE: "store",
  BACK_OFFICE: "back_office",
};

export const MAX_COMMENT_IMAGES = 2;
export const MAX_COMMENT_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB
export const COMMENT_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
];
